import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { DeleteParticipantNote } from '../mutations/deleteParticipantNote.mutation';
import type {
  DeleteParticipantNoteMutation,
  DeleteParticipantNoteMutationVariables,
} from '../types';

export const useDeleteParticipantNoteMutation = (
  options?: MutationOptions<DeleteParticipantNoteMutation, DeleteParticipantNoteMutationVariables>,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(DeleteParticipantNote), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey.includes('participant') || query.queryKey.includes('recording'),
      });
    },
  });
};
